import React, { FC, useEffect, useState } from 'react'
import {
  StyledAccountBilling,
  CurrentPlan,
  PaymentMethod,
  PaymentHistory,
  useAccountSubscription
} from '..'
import { useNotifications } from '../../Notifications'
import { PageLayout, ActionDialog } from '../../System'
import ROUTES from '../../utils/routes'

const AccountBilling: FC = () => {
  const {
    subscriptionInfo,
    loadingSubscription,
    periodEndsInDays,
    actions: { loadSubscriptionInfo, cancelUserSubscription, reactivateUserSubscription }
  } = useAccountSubscription()
  const { addNotification } = useNotifications()

  const [showModal, setShowModal] = useState(false)
  const [processing, setProcessing] = useState(false)

  const handleCancelUserSub = async () => {
    setShowModal(false)
    setProcessing(true)

    try {
      await cancelUserSubscription()
      addNotification({
        message: 'You have successfully unsubscribed.',
        type: 'success',
        interval: 5000
      })
    }
    catch (err) {
      addNotification({
        message: err.message,
        type: 'error',
        interval: 5000
      })
    }

    setProcessing(false)
  }

  const handleReactivateUserSub = async () => {
    setProcessing(true)

    try {
      await reactivateUserSubscription()

      addNotification({
        message: 'You have successfully reactivated your subscription.',
        type: 'success',
        interval: 5000
      })
    }
    catch (err) {
      addNotification({
        message: err.message,
        type: 'error',
        interval: 5000
      })
    }

    setProcessing(false)
  }

  useEffect(() => {
    loadSubscriptionInfo()
  }, [processing])

  return (
    <PageLayout maxWidth={764}>
      <StyledAccountBilling>
        <h1>Billing</h1>
        <CurrentPlan
          subscription={subscriptionInfo}
          loadingSubscription={loadingSubscription}
          setShowModal={setShowModal}
          processing={processing}
          reactivateUserSub={handleReactivateUserSub}
        />
        <hr className="billing-divider" />
        <PaymentMethod subscription={subscriptionInfo} />
        <hr className="billing-divider" />
        <PaymentHistory />
        <ActionDialog
          type="error"
          isOpen={showModal}
          title="Cancel your subscription?"
          body={(
            <span>
              Once cancelled, you will have {periodEndsInDays} days to continue using Social
              Curator. After that period, you will lose access to the content in your dashboard. You
              will not lose access to any courses that you have purchased. Please feel free to check
              out our{' '}
              <a href={ROUTES.external.cancellationPolicyUrl} target="__blank">
                cancelation policy
              </a>{' '}
              for more information on this process.
            </span>
          )}
          cancelButtonText="Don't Cancel"
          confirmButtonText="End Subscription"
          onClose={() => setShowModal(false)}
          onConfirm={() => handleCancelUserSub()}
        />
      </StyledAccountBilling>
    </PageLayout>
  )
}

export default AccountBilling
